<template>
  <div>
    <line-details-dialog :show="showLineDetailsDialog" :initial-values="lineDetailsInitialValues"
      @submit="handleLineDetailsSubmit" @cancel="handleLineDetailsCancel" />
  
    <area-details-dialog :show="showAreaDetailsDialog" :initial-values="areaDetailsInitialValues"
      @submit="handleAreaDetailsSubmit" @cancel="handleAreaDetailsCancel" />
  
    <b-modal v-model="showLoadingModal" title="Loading data, please wait ..." ok-only ok-disabled cancel-disabled
      no-close-on-backdrop no-close-on-esc>
      <span>{{ loadingStatus }}</span>
    </b-modal>
  
    <b-container fluid>
      <b-row>
        <b-col cols="12">
          <b-card :header="$t('editor.editor')">
            <b-row>
              <b-col lg="4">
                <editor-table ref="logbook-table" :map="map" />
              </b-col>
              <b-col>
                <editor-map :map="map" :height="map_size" />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import EditorMap from "@/views/editor/EditorMap.vue";
import EditorTable from "@/views/editor/EditorTable.vue";
import LineDetailsDialog from "./EditorDetailsDialog.vue";
import AreaDetailsDialog from "./AreaDetailsDialog.vue";
import { editor_map, eventBus } from "@/main";
import { myAxios } from "@/services/myAxios";

export default {
  components: { EditorMap, EditorTable, LineDetailsDialog, AreaDetailsDialog },
  data() {
    return {
      windowWidth: window.innerWidth,
      map: editor_map,
      mapHeight: window.innerHeight - 200,
      mapHeightMobile: window.innerHeight - 130,
      showLineDetailsDialog: false,
      showAreaDetailsDialog: false,
      lineDetailsInitialValues: {},
      areaDetailsInitialValues: {},
      lastRegion: '', // Store the last entered region,
      showLoadingModal: false,
      loadingStatus: "",
    }
  },
  beforeMount() {
    eventBus.$on('show-line-details-dialog', this.openLineDetailsDialog);
    eventBus.$on('show-area-details-dialog', this.openAreaDetailsDialog);

    eventBus.$on('map-drag-offset', (offset) => {
      editor_map.offsetCurrentPoints(offset);
    })

    eventBus.$on('editor-data-load-status', (v) => {
      this.showLoadingModal = !!v;
      if (this.showLoadingModal)
        this.loadingStatus = "Loading graph ...";
    });
    eventBus.$on('editor-data-load-message', (v) => {
      this.loadingStatus = v ?? "";
    });
  },
  mounted() {
    myAxios.get('/api/v1/manage/test')

    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    eventBus.$off('map-drag-offset');
    eventBus.$off('show-line-details-dialog', this.openLineDetailsDialog);
    eventBus.$off('show-area-details-dialog', this.openAreaDetailsDialog);
    eventBus.$off('editor-data-load-status');
    eventBus.$off('editor-data-load-message');
  },
  computed: {
    // ...mapStores(useMomentaryStore, useRoutesStore, useLogbookStore, useUserStore, useDeviceStore),
    is_mobile() {
      return (this.windowWidth <= 991) ||
        ('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0)
    },
    map_size() {
      if (this.is_mobile)
        return this.mapHeightMobile
      else
        return window.innerHeight - 200
    },
  },
  methods: {
    openLineDetailsDialog(initialValues) {
      // Apply the last region if it exists and initialValues doesn't have a region
      // Fix: Use Object.prototype.hasOwnProperty.call instead of direct method access
      if (this.lastRegion && (!Object.prototype.hasOwnProperty.call(initialValues, 'region') || initialValues.region === '')) {
        initialValues.region = this.lastRegion;
      }
      this.lineDetailsInitialValues = initialValues;
      this.showLineDetailsDialog = true;
    },
    openAreaDetailsDialog(initialValues) {
      this.areaDetailsInitialValues = initialValues;
      this.showAreaDetailsDialog = true;
    },
    handleLineDetailsSubmit(formData) {
      // Save the region for future use if it's not empty
      if (formData.region) {
        this.lastRegion = formData.region;
      }
      eventBus.$emit('line-details:submit', formData);
      this.showLineDetailsDialog = false;
    },

    handleLineDetailsCancel() {
      eventBus.$emit('line-details:cancel');
      this.showLineDetailsDialog = false;
    },

    handleAreaDetailsSubmit(formData) {
      eventBus.$emit('area-details:submit', formData);
      this.showAreaDetailsDialog = false;
    },

    handleAreaDetailsCancel() {
      eventBus.$emit('area-details:cancel');
      this.showAreaDetailsDialog = false;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
      this.mapHeightMobile = window.innerHeight - 130;
    }
  }
}
</script>